import './ContentFormWithPreview.scss';
import React from 'react';
import { useAppSelector as useSelector } from 'hooks/reduxHooks';
import useSettings from 'hooks/useSetting';
import MultiActionPreview from 'components/ExperienceCanvas/MultiActionPreview/MultiActionPreview';
import { getContentListItems } from 'store/content/content.selector';
import ContentForm from './ContentForm';

const CLASS_PREFIX = 'content-form-with-preview';
const CLASSES = {
  MAIN: CLASS_PREFIX,
  FORM: `${CLASS_PREFIX}__form`,
  PREVIEW: `${CLASS_PREFIX}__preview`,
  PREVIEW_LABEL: `${CLASS_PREFIX}__preview-label`,
  PHONE: `${CLASS_PREFIX}__phone`,
};

type ContentFormWithPreviewProps = {
  stepIdx: number;
};

export default function ContentFormWithPreview({ stepIdx }: ContentFormWithPreviewProps) {
  const contents = useSelector((state) => getContentListItems(state, stepIdx));
  const { languages, previewTextLanguage: previewTextLanguageKey } = useSettings();
  const previewTextLanguage = languages.find((lang) => lang.id === previewTextLanguageKey);

  return (
    <div className={CLASSES.MAIN}>
      <div className={CLASSES.FORM}>
        <ContentForm stepIdx={stepIdx} isJourneyLocked readOnly />
      </div>
      <div className={CLASSES.PREVIEW}>
        <MultiActionPreview
          className={CLASSES.PHONE}
          isFullPreview={false}
          contents={contents}
          showPreview="content"
          language={previewTextLanguage}
        />
      </div>
    </div>
  );
}
